import { render, staticRenderFns } from "./window-quarternary.vue?vue&type=template&id=8496e5c2&scoped=true&"
import script from "./window-quarternary.vue?vue&type=script&lang=js&"
export * from "./window-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8496e5c2",
  null
  
)

export default component.exports